export { default as ReturnAddressListTemplate } from './ReturnAddressListTemplate';
export { default as ReturnAddressEditTemplate } from './ReturnAddressEditTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/return-address/pages/index.js